import React from 'react'

import { TextField, RadioGroup } from '@masfront/common-b2c'
import { FastField, Field } from 'formik'

import {
  Box,
  Typography,
  Grid,
  InputAdornment,
  Collapse,
  FormControlLabel,
  Radio,
} from '@material-ui/core'

import useDonorOwner from './useDonorOwner'

export default function DonorOwner({ id }: { id: string }) {
  const { docType, showDonorOwner, showPersonalInputs, owners } = useDonorOwner()

  return (
    <>
      <Box display="flex">
        <Box mr={4} display="flex" alignItems="center">
          <Typography>Titular de origen: </Typography>
        </Box>
        <Field component={RadioGroup} name="isSameOwner" data-hook="isSameOwner">
          {owners.map(({ value, label }) => (
            <FormControlLabel
              key={`${id}.isSameOwner-${value}`}
              value={value}
              control={<Radio color="primary" />}
              label={<Typography variant="subtitle2">{label}</Typography>}
            />
          ))}
        </Field>
      </Box>
      <Collapse in={showDonorOwner}>
        <Grid container component={Box} pt={7} spacing={5}>
          <Grid xs={3} item>
            <Field
              component={TextField}
              name="donorOwner.docId"
              label="Documento"
              variant="outlined"
              inputProps={{
                maxLength: 9,
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Typography
                      variant="caption"
                      color="textSecondary"
                      data-hook="donorOwner.docType"
                    >
                      {docType}
                    </Typography>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>

          {showPersonalInputs ? (
            <>
              <Grid xs={3} item>
                <FastField
                  component={TextField}
                  name="donorOwner.name"
                  label="Nombre"
                  variant="outlined"
                />
              </Grid>
              <Grid xs={3} item>
                <FastField
                  component={TextField}
                  name="donorOwner.firstName"
                  label="Primer Apellido"
                  variant="outlined"
                />
              </Grid>
              <Grid xs={3} item>
                <FastField
                  component={TextField}
                  name="donorOwner.lastName"
                  label="Segundo Apellido"
                  variant="outlined"
                />
              </Grid>
            </>
          ) : (
            <Grid xs={3} item>
              <FastField
                component={TextField}
                name="donorOwner.companyName"
                label="Empresa"
                variant="outlined"
              />
            </Grid>
          )}
        </Grid>
      </Collapse>
    </>
  )
}
